import React, { useContext, useEffect, useMemo } from 'react'
import Header from './Header'
import Footer from './Footer'
import { Outlet, useLocation } from 'react-router-dom'
import { ProjectTypeEnum, ThemeTypes } from '../../models/SharedModel'
import { ThemeContext } from '../../models/ThemeContext'

const Layout = () => {
  const { pathname } = useLocation();

const className = useMemo(() => pathname?.split('/').join(' ')?.trim() || 'default', [pathname]);
const { themeName } = useContext(ThemeContext);

const exceptionUrlList = [ProjectTypeEnum.DATA_ANALYTICS, ProjectTypeEnum.DOCUMENT_AI,ProjectTypeEnum.RESEARCH_INSIGHTS].map(str => str.toLowerCase());
const exceptionUrls = (pathname:any) =>{
const searchString = pathname?.split("/")?.[2];
if (exceptionUrlList.includes(searchString)) {
  return false;
}
return true
}

useEffect(()=>{
  exceptionUrls(pathname)
},[pathname])
  return (
    // Chenges from blue theme
    // <div className={`${(themeName === ThemeTypes?.BLUE_THEME) ? 'layout' : 'dark-layout'}`}>
    <div className={`${(themeName === ThemeTypes?.BLUE_THEME) ? 'layout' : 'dark-layout'}`}>
      {/* {(themeName === ThemeTypes?.BLUE_THEME) && (pathname?.split("/")?.[2] !== ProjectTypeEnum.RESEARCH_INSIGHTS)
      
      && (pathname?.split("/")?.[2] !== ProjectTypeEnum.DOCUMENT_AI)  && <Header />} */}
      <div className={`${'layout-inner'}  ${exceptionUrls(pathname) && className}`}>
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}

export default Layout